import OwnerIndividual from 'src/models/tract_detail/add_ownership_revised/OwnerIndividual';
import Ownership from 'src/models/tract_detail/add_ownership_revised/Ownership';
import OwnerTrust from './OwnerTrust';
import OwnerBusiness from './OwnerBusiness';
import OwnerBOLM from './OwnerBOLM';
import OwnerRAL from './OwnerRAL';
import OwnerStateLand from './OwnerStateLand';
import OwnerJointTenant from './OwnerJointTenant';

export default class AddOwnership {
    id: number;
    horizonId: number;
    ownerType: number;
    individualOwner: OwnerIndividual;
    ownerTrust: OwnerTrust;
    businessOwner: OwnerBusiness;
    bolmOwner: OwnerBOLM;
    ralOwner: OwnerRAL;
    stateLandOwner: OwnerStateLand;
    ownership: Ownership;
    ownerLookUpId: number;
    parentOwnershipId: number;
    ownershipType: number;
    additionalOwnershipTypeId: number;
    ownerJointTenant: OwnerJointTenant;
    isCommunityProperty: number;
}



// WEBPACK FOOTER //
// ./src/models/tract_detail/add_ownership_revised/AddOwnership.ts